"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TextFormat = _interopRequireDefault(require("@material-ui/icons/TextFormat"));

var _AttachFile = _interopRequireDefault(require("@material-ui/icons/AttachFile"));

var _InsertLink = _interopRequireDefault(require("@material-ui/icons/InsertLink"));

var _constants = require("./constants");

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _reactI18next = require("react-i18next");

var _contexts = require("./contexts");

var _context = require("../TinymceEditor/context");

var _utils = require("../TinymceEditor/utils");

var toolClassName = 'rounded p-2 hover:bg-secondary focus:bg-secondary border border-transparent focus:border-ultra-light ml-2';

var Button = function Button(_ref) {
  var tooltip = _ref.tooltip,
      actived = _ref.actived,
      type = _ref.type,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["tooltip", "actived", "type"]);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, rest, {
    tabIndex: "0",
    className: (0, _classnames["default"])(toolClassName, {
      'bg-secondary': actived,
      'text-primary': actived,
      'hover:text-primary-active': actived,
      'focus:text-primary-active': actived
    })
  })));
};

var _default = function _default(_ref2) {
  var onShowUploadDialog = _ref2.onShowUploadDialog,
      onUpdateActiveTool = _ref2.onUpdateActiveTool,
      className = _ref2.className,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
  var editor = (0, _context.useEditor)();

  var _useContext = (0, _react.useContext)(_contexts.ActiveToolContext),
      activeTool = _useContext.activeTool,
      setActiveTool = _useContext.setActiveTool;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var handleToggleActiveTool = function handleToggleActiveTool(e, toolType) {
    var newActiveTool = activeTool === toolType ? _constants.TOOL_NONE : toolType;

    if (newActiveTool === _constants.TOOL_LINK) {
      if ((0, _utils.insertLinkDirectly)(editor)) {
        return;
      }
    }

    setActiveTool(newActiveTool);

    if (onUpdateActiveTool) {
      onUpdateActiveTool(newActiveTool);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex text-gray-light', className)
  }, /*#__PURE__*/_react["default"].createElement(Button, {
    tooltip: t('button.formattingOptions'),
    onClick: function onClick(e) {
      editor.focus();
      handleToggleActiveTool(e, _constants.TOOL_FORMATTING);
    },
    actived: activeTool === _constants.TOOL_FORMATTING,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_TextFormat["default"], null)), /*#__PURE__*/_react["default"].createElement(Button, {
    tooltip: t('button.attachFiles'),
    onClick: function onClick(e) {
      e.preventDefault();
      onShowUploadDialog();
    },
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_AttachFile["default"], null)), /*#__PURE__*/_react["default"].createElement(Button, {
    tooltip: t('button.insertLink'),
    onClick: function onClick(e) {
      return handleToggleActiveTool(e, _constants.TOOL_LINK);
    },
    actived: activeTool === _constants.TOOL_LINK,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_InsertLink["default"], null)));
};

exports["default"] = _default;
//# sourceMappingURL=Toolbar.js.map